import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

const initialState = {
    defaultEntity: {
        id: 0,
        codigo: "",
        nombre: "",
        idTipo: 0,
        tipo: "",
        // Clase en catalogo (hijos de "Clases de puntuacion"): 321 sesiones,
        // 322 planificacion.
        idClase: 0,
        clase: "",
        valorMinimo: null,
        valorMaximo: null,
        idEstado: 2,
        estado: "Activo",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    entity: {
        id: 0,
        codigo: "",
        nombre: "",
        idTipo: 0,
        tipo: "",
        idClase: 0,
        clase: "",
        valorMinimo: null,
        valorMaximo: null,
        idEstado: 2,
        estado: "Activo",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    listTipos: [{id: 0, descripcion: ""}],
    listClases: [{id: 0, descripcion: ""}],
    listEstados: [{id: 0, descripcion: ""}],
    validationActive: {
        codigo: false,
        nombre: false,
        idTipo: false,
        idClase: false,
        idEstado: false,
    },
    validationMessage: [],
}

export const puntuacionSlice = createSlice({
    name: "puntuacion",
    initialState,
    reducers: {
        setEntity: (state, action) => {
            state.entity = action.payload;
        },
        setData: (state, action) => {
            var { name, value } = action.payload;

            // parseInt("") o parseInt(null) dan NaN y ese NaN viaja en el
            // payload: se convierte en 0 (sin seleccionar) en vez de en NaN.
            if (name.startsWith("id")) value = (value === "" || value === null || value === undefined)
                ? 0 : parseInt(value)

            state.entity[name] = value
            state.validationActive[name] = true
        },
        setValidationMessage: (state, action) => {
            state.validationMessage = action.payload;
        },
        activeValidations: (state, action) => {
            Object.keys(state.validationActive).forEach(function (key) {
                state.validationActive[key] = true;
            })
        },
        setListTipos: (state, action) => {
            state.listTipos = action.payload;
        },
        setListClases: (state, action) => {
            state.listClases = action.payload;
        },
        setListEstados: (state, action) => {
            state.listEstados = action.payload;
        },
    },
});

export const { setEntity, setData, setValidationMessage, activeValidations
    , setListTipos, setListClases, setListEstados } = puntuacionSlice.actions;
export default puntuacionSlice.reducer;